import React from "react";
import "./client.scss";
import "./client.scss";
import Img from "../../../assets/Group 198.svg";
import Img2 from "../../../assets/clientimages/Frame 1000004665.svg";
import Img1 from "../../../assets/clientimages/Wanbury Limited 3 1.svg";
import Img3 from "../../../assets/clientimages/Frame 1000004668.svg";
import Img4 from "../../../assets/clientimages/Frame 1000004670.svg";
import Img5 from "../../../assets/clientimages/image 66.svg";
import Img6 from "../../../assets/clientimages/Frame 1000004671.svg";
import Img7 from "../../../assets/clientimages/Frame 1000004670-1.svg";
import Img8 from "../../../assets/clientimages/Frame 1000004670-2.svg";
import Img9 from "../../../assets/clientimages/Frame 1000004671 2.svg";
import Img10 from "../../../assets/clientimages/Frame 1000004670 2.svg";
import Img11 from "../../../assets/clientimages/Frame 1000004670-1 2.svg";
import Img12 from "../../../assets/clientimages/Frame 1000004670-2 2.svg";
import Img13 from "../../../assets/clientimages/Frame 1000004670-3.svg";
import Img14 from "../../../assets/clientimages/Frame 1000004670-4.svg";
import Img15 from "../../../assets/clientimages/Frame 1000004670-5.svg";
import Img16 from "../../../assets/clientimages/image 59.svg";
import Img17 from "../../../assets/clientimages/image 25.svg";
import Img18 from "../../../assets/clientimages/image 58.svg";
import Img19 from "../../../assets/clientimages/image 52.svg";
import Img20 from "../../../assets/clientimages/image 56.svg";
import Img21 from "../../../assets/clientimages/image 55.svg";
import Img22 from "../../../assets/clientimages/image 57.svg";
import Img23 from "../../../assets/clientimages/image 53.svg";
import Img24 from "../../../assets/clientimages/image 67.svg";
import Img25 from "../../../assets/clientimages/image 51.svg";
import Img26 from "../../../assets/clientimages/image 65.svg";
import Img27 from "../../../assets/clientimages/image 61.svg";
import Img28 from "../../../assets/clientimages/image 62.svg";
import Img29 from "../../../assets/clientimages/image 50.svg";

const clients = [
  {
    name: "Wanbury LTD.",
    image: Img1,
  },
  {
    name: "Maa mahamaya Industries",
    image: Img2,
  },
  {
    name: "Filatex India LTD.",
    image: Img3,
  },
  {
    name: "Bhushan Power & Steel LTD.",
    image: Img4,
  },
  {
    name: "Mantri developers",
    image: Img5,
  },
  {
    name: "autolite(India) LTD.",
    image: Img6,
  },
  {
    name: "Dhandapani Finance LTD.",
    image: Img7,
  },
  {
    name: "Prakash Industries LTD.",
    image: Img8,
  },
  {
    name: "Rollatainers Group",
    image: Img9,
  },
  {
    name: "Educomp Solutions LTD.",
    image: Img10,
  },
  {
    name: "Jyoti Structures Limited LTD.",
    image: Img11,
  },
  {
    name: "Prius group of Company",
    image: Img12,
  },
  {
    name: "DS Group",
    image: Img13,
  },
  {
    name: "Amtek Group",
    image: Img14,
  },
  {
    name: "Electrosteel Castings LTD.",
    image: Img15,
  },
  {
    name: "Concast Group",
    image: Img16,
  },
  {
    name: "Uttam Galva Steels LTD.",
    image: Img17,
  },
  {
    name: "jindal Stainless Ltd.",
    image: Img18,
  },
  {
    name: "Tourism Finance Corporation of India Ltd.",
    image: Img19,
  },
  {
    name: "Akar Tools Ltd.",
    image: Img20,
  },
  {
    name: "Suncity Projects Pvt. Ltd.",
    image: Img21,
  },
  {
    name: "Express Roadways Pvt.Ltd.",
    image: Img22,
  },
  {
    name: "Pitti Laminations Ltd.",
    image: Img23,
  },
  {
    name: "Himalaya City Centre",
    image: Img24,
  },
  {
    name: "KSK Power company Ltd.",
    image: Img25,
  },
  {
    name: "DB Reality Limited",
    image: Img26,
  },
  {
    name: "Electrosteel Castings LTD.",
    image: Img27,
  },
  {
    name: "Alps Industries Ltd.",
    image: Img28,
  },
  {
    name: "Adhunik Group",
    image: Img29,
  },
];

const Clients = () => {
  return (
    <div className="clients">
      <div className="container">
        <div className="d-flex clients-container flex-wrap align-items-center">
          <div className="col-sm-5 order-1 order-sm-2">
            <div className="clients-image">
              <h3>
                Clients <span>We Served</span>
              </h3>
              <p>Trusted by over 50+ businesses worldwide</p>
              <img className="mt-5" src={Img} alt="Clients We Served" />
            </div>
          </div>

          <div className="col-sm-7 order-2 order-sm-1">
            <div className="clients-content">
              <div className="row row-cols-6 px-0">
                {clients.map((client, index) => (
                  <div
                    className={`content ${
                      client.name === "Prius group of Company"
                        ? "d-flex align-items-center"
                        : ""
                    }`}
                    key={index}
                  >
                    <img src={client.image} alt={client.name} />
                    <p>{client.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Clients;
